import { finalizeDocumentAsync } from '../../API/order/documents/DocumentsAPI';
import { createAsyncSliceWithDataAndQuery } from '../createAsyncSliceWithDataAndQuery';

export const { slice: finalizeDocumentSlice, asyncAction: finalizeDocumentAction } = createAsyncSliceWithDataAndQuery(
  'finalizeDocument',
  finalizeDocumentAsync,
  { documentId: null, versionId: null }
);
